import React from 'react';
import loadable from '@loadable/component';
import LazyComponentFallback from '../LazyComponentFallback';

const FAQ = loadable(() => import('./components/FAQ'), {
  fallback: <LazyComponentFallback />
});

export default FAQ;
